import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR } from '../../../services/search-service';
import { CuentasService } from '../../../services/cuentas-service';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';
import * as moment from 'moment';
import { CuentaAutocompleteComponent } from '../../../components/common/autocomplete';

@Component({
  selector: 'app-buscador-colaboradores-filter',
  templateUrl: './buscador-colaboradores-filter.component.html',
  styleUrls: ['./buscador-colaboradores-filter.component.scss']
})
export class BuscadorColaboradoresFilterComponent implements OnInit {

  private moreActiveFirst = false;
  public showFilters = false;
  
  @Output() onFiltersApplied = new EventEmitter();
  
  @ViewChild(CuentaAutocompleteComponent) cuentaAutocompleteComponent;

  constructor(private dateAdapter: DateAdapter<Date>,
              private cuentasService: CuentasService,
              private searchService: SearchService) { 

  }

  ngOnInit() {
  }

  onApply(e){
    // dont hide the filter window when clicking the apply button
    e.stopPropagation();

    this.onFiltersApplied.emit({
      moreActiveFirst: this.moreActiveFirst,
      cuentas: this.cuentaAutocompleteComponent.selectedCuentas
    });
  }

  cleanFilters(e) {
    this.moreActiveFirst = false;
    this.cuentaAutocompleteComponent.selectedCuentas = [];

    this.onApply(e);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/buscador/buscador-colaboradores-filter/buscador-colaboradores-filter.component.ts